import React from 'react';
import PropTypes from 'prop-types';

import { smoothScrollTo } from 'common/utils';
import { TranslatedMessage } from 'common/components/Intl';

import accessoriesIcon from 'images/product-navigation/accessories.svg';
import devicesIcon from 'images/product-navigation/devices.svg';
import juulpodsIcon from 'images/product-navigation/juulpods.svg';
import portableChargingCaseIcon from 'images/product-navigation/portable-charging-case.svg';
import starterKitIcon from 'images/product-navigation/starter-kit.svg';
import usbChargingDockIcon from 'images/product-navigation/usb-charging-dock.svg';

export const productNavigationData = {
  accessories: {
    name: <TranslatedMessage id="accessories" />,
    icon: accessoriesIcon,
  },
  devices: {
    name: <TranslatedMessage id="devices" />,
    icon: devicesIcon,
  },
  juulpods: {
    name: <TranslatedMessage id="juulpods" />,
    icon: juulpodsIcon,
  },
  'portable-charging-case': {
    name: <TranslatedMessage id="portable_charging_case" />,
    icon: portableChargingCaseIcon,
  },
  'starter-kit': {
    name: <TranslatedMessage id="starter_kit" />,
    icon: starterKitIcon,
  },
  'usb-charging-dock': {
    name: <TranslatedMessage id="usb_charging_dock" />,
    icon: usbChargingDockIcon,
  },
};

const ProductNavigationItem = ({ target }) => {
  const targetData = productNavigationData[target];
  if (!targetData) {
    return null;
  }

  const handleClick = event => {
    event.preventDefault();
    smoothScrollTo(`#${target}`);
  };

  return (
    <a
      className="product-navigation__item"
      href={`#${target}`}
      onClick={handleClick}
    >
      <img
        alt=""
        src={targetData['icon']}
        className="product-navigation__item-image"
      />
      <div className="product-navigation__item-text subheading--small">
        {targetData['name']}
      </div>
    </a>
  );
};

export const ProductNavigationTargetOptions = PropTypes.oneOf([
  'accessories',
  'devices',
  'juulpods',
  'portable-charging-case',
  'starter-kit',
  'usb-charging-dock',
]);

ProductNavigationItem.propTypes = {
  target: ProductNavigationTargetOptions.isRequired,
};

export default ProductNavigationItem;
